/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import AddingAttachementIcon from "../../../assests/img/Adding-Attachment-Icon.svg";
import AttachementRemoveIcon from "../../../assests/img/Attachement-close-icon.svg";
import PdfFileIcon from "../../../assests/img/pdf-file-icon.svg";
import CSVIcon from "../../../assests/img/csv.svg";
import XLSXIcon from "../../../assests/img/xlsx.svg";
import PowerPointIcon from "../../../assests/img/powerpoint.svg";
import VideoIcon from "../../../assests/img/video.svg";
import DocIcon from "../../../assests/img/doc.svg";
import ZipIcon from "../../../assests/img/zip.svg";

const ChangeStatusModal = ({
  show,
  onHide,
  modalButtonValue,
  handleAddComment,
  onSubmit,
  ticket,
  allData,
  commentbox,
  setCommentBox,
  commentType,
  setCommentType,
  uploadedFilesComment,
  setUploadedFilesComment,
  handleReassign,
  reassignbox,
  setReassignBox,
  uploadedFilesReassign,
  setUploadedFilesReassign,
  handleIrrelevant,
  irrelevantBox,
  setIrrelevantBox,
  uploadedFilesIrrelevant,
  setUploadedFilesIrrelevant,
  selectedAssignee,
  setSelectedAssignee,
  handleChangeAssignee,
  filteredAssignees,
  allTicketData,
  groupTypeForExComment,
  groupTypeOpsExist,
}) => {
  // State for dynamic fields
  const [formData, setFormData] = useState({});
  const [uploadedResFilesDis, setUploadedResFilesDis] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [clientResponseRequired, setClientResponseRequired] = useState(false);
  const fileInputRefs = useRef({});
  const fileInputRef4 = useRef({});
  const fileInputRef5 = useRef({});
  const fileInputRef6 = useRef({});

  // Reset clientResponseRequired when modal opens/closes
  useEffect(() => {
    if (show) {
      setClientResponseRequired(false);
    }
  }, [show]);

  // Find current status configuration
  const currentStatus = ticket?.statusOption?.find(
    (option) => option.status === modalButtonValue
  ) || { fields: [] };

  // Initialize form data and restore allData handling
  useEffect(() => {
    const initialFormData = {};
    currentStatus?.fields?.forEach((field) => {
      initialFormData[field.key] = field.type === "file" ? [] : "";
    });
    setFormData(initialFormData);

    // Restore allData handling
    for (let index = 0; index < allData?.length; index++) {
      const element = allData[index];
      if (element.action === "updated an action") {
        const resolutionField = currentStatus?.fields?.find(
          (f) => f.key === "resolution"
        );
        if (resolutionField) {
          setFormData((prev) => ({ ...prev, resolution: element.subject }));
        }
        if (element.attachment) {
          setUploadedResFilesDis(element.attachment);
        }
        return;
      }
    }
  }, [allData, ticket, modalButtonValue, show]);

  // Reset state on close
  const onCrossClick = () => {
    setFormData({});
    setUploadedResFilesDis([]);
    //  setCommentBox("");
    //setUploadedFilesComment([]);
    //  setReassignBox("");
    // setUploadedFilesReassign([]);
    // setSelectedAssignee("");
    onHide();
  };

  // Toast notification
  const showToast = (message) => {
    toast.error(message);
  };

  // Handle text input changes
  const handleTextChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  // Handle file input changes
  const handleFileChange = (key, event) => {
    const files = Array.from(event.target.files);
    const currentFiles = formData[key] || [];
    const totalFiles = currentFiles?.length + files?.length;

    if (totalFiles > 10) {
      showToast("Maximum 10 attachments is allowed");
      return;
    }

    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 100 * 1024 * 1024) {
      showToast("Maximum size will be 100mb");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [key]: [...currentFiles, ...files],
    }));

    // Clear the file input value
    if (fileInputRefs.current[key]) {
      fileInputRefs.current[key].value = "";
    }
  };

  // Handle comment file changes
  const handleFileCommentChange = (event) => {
    const files = Array.from(event.target.files);
    const totalFiles = uploadedFilesComment.length + files.length;
    if (totalFiles > 10) {
      showToast("Maximum 10 attachments is allowed");
      return;
    }
    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 100 * 1024 * 1024) {
      showToast("Maximum size will be 100mb");
      return;
    }
    setUploadedFilesComment([...uploadedFilesComment, ...files]);

    // Clear the file input value
    if (fileInputRef4.current) {
      fileInputRef4.current.value = "";
    }
  };

  // Handle reassign file changes
  const handleFileReassignChange = (event) => {
    const files = Array.from(event.target.files);
    const totalFiles = uploadedFilesReassign.length + files.length;
    if (totalFiles > 10) {
      showToast("Maximum 10 attachments is allowed");
      return;
    }
    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 100 * 1024 * 1024) {
      showToast("Maximum size will be 100mb");
      return;
    }
    setUploadedFilesReassign([...uploadedFilesReassign, ...files]);

    // Clear the file input value
    if (fileInputRef5.current) {
      fileInputRef5.current.value = "";
    }
  };

  const handleFileIrrelevantChange = (event) => {
    const files = Array.from(event.target.files);
    const totalFiles = uploadedFilesIrrelevant.length + files.length;
    if (totalFiles > 10) {
      showToast("Maximum 10 attachments is allowed");
      return;
    }
    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > 100 * 1024 * 1024) {
      showToast("Maximum size will be 100mb");
      return;
    }
    setUploadedFilesIrrelevant([...uploadedFilesIrrelevant, ...files]);

    // Clear the file input value
    if (fileInputRef6.current) {
      fileInputRef6.current.value = "";
    }
  };

  // Remove file
  const handleRemoveFile = (key, index) => {
    setFormData((prev) => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index),
    }));
  };

  const handleRemoveImageComment = (index) => {
    const updatedFiles = [...uploadedFilesComment];
    updatedFiles.splice(index, 1);
    setUploadedFilesComment(updatedFiles);
  };

  const handleRemoveImageReassign = (index) => {
    const updatedFiles = [...uploadedFilesReassign];
    updatedFiles.splice(index, 1);
    setUploadedFilesReassign(updatedFiles);
  };

  const handleRemoveImageIrrelevant = (index) => {
    const updatedFiles = [...uploadedFilesIrrelevant];
    updatedFiles.splice(index, 1);
    setUploadedFilesIrrelevant(updatedFiles);
  };

  // Trigger file input
  const handleIconClick = (key) => {
    if (fileInputRefs.current[key]) {
      fileInputRefs.current[key].click();
    }
  };

  const handleIconClickComment = () => {
    if (fileInputRef4.current) {
      fileInputRef4.current.click();
    }
  };
  const handleIconClickReassign = () => {
    if (fileInputRef5.current) {
      fileInputRef5.current.click();
    }
  };

  const handleIconClickIrrelevant = () => {
    if (fileInputRef6.current) {
      fileInputRef6.current.click();
    }
  };

  // MIME type detection
  const getMimeType = (url) => {
    const extension = url.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "docx":
      case "heic":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return `image/${extension}`;
      case "mp4":
        return "video/mp4";
      case "mov":
        return "video/mov";
      case "webm":
        return "video/webm";
      case "ppt":
        return "application/vnd.ms-powerpoint";
      case "csv":
        return "text/csv";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case "zip":
        return "application/zip";
      default:
        return "application/octet-stream";
    }
  };

  // Trim file names
  const trimFileName = (name) => {
    const maxLength = 30;
    const extension = name.split(".").pop();
    const nameWithoutExt = name.slice(0, -(extension.length + 1));
    return nameWithoutExt.length > maxLength
      ? `${nameWithoutExt.slice(0, maxLength)}....${extension}`
      : name;
  };

  // Submit handler
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const selectedStatusOption = ticket?.statusOption?.find(
        (option) => option.status === modalButtonValue
      );

      if (!selectedStatusOption) {
        showToast("Invalid status selected.");
        return;
      }

      // Dynamically pick the keys and values
      const submissionValues = {};

      selectedStatusOption.fields.forEach((field) => {
        submissionValues[field.key] =
          formData[field.key] ?? (field.type === "file" ? [] : null);
      });

      // Pass entire values object to parent handler
      await onSubmit(modalButtonValue, submissionValues, uploadedResFilesDis);

      onCrossClick();
    } catch (error) {
      // showToast("Submission failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitComment = async () => {
    setIsLoading(true);
    await handleAddComment(
      commentbox,
      uploadedFilesComment,
      commentType,
      clientResponseRequired
    );
    setIsLoading(false);
  };

  const handleSubmitReassign = async () => {
    setIsLoading(true);
    await handleReassign(reassignbox, uploadedFilesReassign, selectedAssignee);
    setIsLoading(false);
  };

  const handleSubmitIrrelevant = async () => {
    setIsLoading(true);
    await handleIrrelevant(
      irrelevantBox,
      uploadedFilesIrrelevant,
      allTicketData?.isIrrelevant === true ? false : true
    );
    setIsLoading(false);
  };

  // Render field
  const renderField = (field, isResolution = false) => {
    const { key, type, title, placeholder } = field;

    switch (type) {
      case "text":
        return (
          <div className="AddNoteToTicket" key={key}>
            <div className="mb-3">
              <textarea
                className="form-control"
                value={formData[key] || ""}
                onChange={(e) => handleTextChange(key, e.target.value)}
                rows="3"
                placeholder={placeholder}
              />
            </div>
          </div>
        );

      case "file":
        return (
          <div className="AddNoteToTicket pt-0" key={key}>
            <div className={`AtachedFileShow ${isResolution ? "mx-2" : ""}`}>
              {(formData[key] || []).map((file, index) => (
                <div className="AtachedFileBox" key={index}>
                  {(() => {
                    const mimeType = getMimeType(file.name);
                    switch (mimeType) {
                      case "application/pdf":
                        return (
                          <>
                            <img
                              src={PdfFileIcon}
                              alt="PDF"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "application/zip":
                        return (
                          <>
                            <img
                              src={ZipIcon}
                              alt="Zip"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "video/mp4":
                      case "video/mov":
                      case "video/webm":
                        return (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "text/csv":
                        return (
                          <>
                            <img
                              src={CSVIcon}
                              alt="CSV"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "application/vnd.ms-powerpoint":
                        return (
                          <>
                            <img
                              src={PowerPointIcon}
                              alt="PowerPoint"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                        return (
                          <>
                            <img
                              src={DocIcon}
                              alt="Doc"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                        return (
                          <>
                            <img
                              src={XLSXIcon}
                              alt="XLSX"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        );
                      default:
                        return (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`uploaded-file-${index}`}
                            style={{
                              objectFit: "cover",
                              width: "60px",
                              height: "60px",
                            }}
                          />
                        );
                    }
                  })()}
                  <div className="AtachedFileBox_Overlay">
                    <img
                      src={AttachementRemoveIcon}
                      alt="Remove"
                      onClick={() => handleRemoveFile(key, index)}
                    />
                  </div>
                </div>
              ))}
              {isResolution &&
                uploadedResFilesDis.map((file, index) => (
                  <div className="AtachedFileBox" key={`dis-${index}`}>
                    {(() => {
                      const mimeType = getMimeType(file);
                      switch (mimeType) {
                        case "application/pdf":
                          return (
                            <>
                              <img
                                src={PdfFileIcon}
                                alt="PDF"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "application/zip":
                          return (
                            <>
                              <img
                                src={ZipIcon}
                                alt="Zip"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "video/mp4":
                        case "video/mov":
                        case "video/webm":
                          return (
                            <>
                              <img
                                src={VideoIcon}
                                alt="Video"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "text/csv":
                          return (
                            <>
                              <img
                                src={CSVIcon}
                                alt="CSV"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "application/vnd.ms-powerpoint":
                          return (
                            <>
                              <img
                                src={PowerPointIcon}
                                alt="PowerPoint"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                          return (
                            <>
                              <img
                                src={DocIcon}
                                alt="Doc"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                          return (
                            <>
                              <img
                                src={XLSXIcon}
                                alt="XLSX"
                                style={{ objectFit: "cover" }}
                              />
                              <div className="FileName1">
                                {trimFileName(file)}
                              </div>
                            </>
                          );
                        default:
                          return (
                            <img
                              src={file}
                              alt={`uploaded-file-${index}`}
                              style={{
                                objectFit: "cover",
                                width: "60px",
                                height: "60px",
                              }}
                            />
                          );
                      }
                    })()}
                    <div className="AtachedFileBox_Overlay"></div>
                  </div>
                ))}
            </div>
            <div className="ModalToolCTA ModalToolCTA_Backend_C d-flex">
              <a
                className="ModalToolCTA_AttacheFile"
                role="button"
                onClick={() => handleIconClick(key)}
              >
                <img src={AddingAttachementIcon} alt="Attach" />
              </a>
              <input
                type="file"
                ref={(el) => (fileInputRefs.current[key] = el)}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(key, e)}
                multiple
              />
              {field.required &&
              (!formData[key] || formData[key].length === 0) ? (
                <div className="ms-2">
                  <span className="text-danger"> *</span>
                  Attach relevant files (Attachment required)
                </div>
              ) : (
                <div className="ms-2">Attach relevant files</div>
              )}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  // Determine submit button disabled state
  const isSubmitDisabled = () => {
    if (isLoading) return true;

    // Check all required fields in currentStatus
    const hasMissingRequiredFields = currentStatus.fields.some((field) => {
      if (field.required) {
        if (field.type === "text") {
          return !formData[field.key]?.trim();
        }
        if (field.type === "file") {
          return !formData[field.key]?.length;
        }
      }
      return false;
    });

    if (modalButtonValue === "Comments") {
      return !commentbox.trim();
    }
    if (modalButtonValue === "Reassign") {
      return !reassignbox.trim() || !selectedAssignee;
    }

    return hasMissingRequiredFields;
  };

  // Check if modal should be shown (only for status-based modals)
  const shouldShowStatusModal =
    currentStatus && currentStatus?.fields?.length > 0;

  const handleCheckboxChange = (e) => {
    if (!groupTypeForExComment) {
      toast.error(
        "Your department does not have access to this feature",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return; // Prevent checking the checkbox
    }
    setCommentType(e.target.checked);
  };

  return (
    <Modal
      size="lg"
      show={
        show &&
        (shouldShowStatusModal ||
          ["Comments", "Reassign", "Details", "Irrelevant"].includes(
            modalButtonValue
          ))
      }
      onHide={onCrossClick}
      dialogClassName="modal-90w ChangeStatusModal"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        {modalButtonValue === "Details" ? (
          <div className="ChangeStatusModalHead d-flex align-items-center justify-content-between">
            <h3>
              <span className="text-danger">*</span> Check details for more
              information.
            </h3>
            <div style={{ fontSize: "13px" }}>22nd April 2024, 08:30 AM</div>
            <a
              type="button"
              className="ChangeStatusModal_Close btn-close"
              aria-label="Close"
              onClick={onCrossClick}
            />
          </div>
        ) : (
          <div className="ChangeStatusModalHead d-flex align-items-center justify-content-between">
            <h3>
              <span className="text-danger">*</span> Action needed
            </h3>
            <a
              type="button"
              className="ChangeStatusModal_Close btn-close"
              aria-label="Close"
              onClick={onCrossClick}
            />
          </div>
        )}

        {/* Status-based Modal */}
        {shouldShowStatusModal && (
          <>
            <div className="ChangeStatusModalBody">
              <div
                className={`ChangeStatusModalContent ${
                  currentStatus.fields.some((field) =>
                    ["resolution", "resolutionFile"].includes(field.key)
                  )
                    ? "ChangeStatusModalContent_BC"
                    : "HHHHHH"
                }`}
              >
                {currentStatus.fields
                  .filter(
                    (field) =>
                      !["resolution", "resolutionFile"].includes(field.key)
                  )
                  .map((field) => (
                    <React.Fragment key={field.key}>
                      {field?.title?.trim() && (
                        <div className="ticketDetails_UserInfo d-flex align-items-center">
                          <div className="d-flex align-items-center">
                            <div className="ticketDetails_Name">
                              {field.title}
                            </div>
                          </div>
                          <div></div>
                        </div>
                      )}
                      {renderField(field)}
                    </React.Fragment>
                  ))}
              </div>
            </div>

            {currentStatus.fields.some((field) =>
              ["resolution", "resolutionFile"].includes(field.key)
            ) && (
              <div className="ReplySolutionContainer ChangeStatusModalContent_BC2">
                {currentStatus.fields
                  .filter((field) =>
                    ["resolution", "resolutionFile"].includes(field.key)
                  )
                  .map((field) => (
                    <React.Fragment key={field.key}>
                      {field?.title?.trim() && (
                        <div className="ReplySolution_Title">{field.title}</div>
                      )}
                      {renderField(field, true)}
                    </React.Fragment>
                  ))}
              </div>
            )}

            <div className="ChangeStatusModalFoot">
              <div className="ChangeStatusModalFoot_content">
                <div className="ModalToolCTA"></div>
                <div className="ModalCTA">
                  <button
                    className="btn btn-dark ModalCTA_Dark"
                    onClick={handleSubmit}
                    disabled={isSubmitDisabled()}
                  >
                    {isLoading ? (
                      <>
                        <i className="fa fa-refresh fa-spin"></i> Processing
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {/* //Comments */}

        {modalButtonValue === "Comments" && (
          <>
            <div className="ChangeStatusModalBody AddCommentModalBody">
              <div className="ChangeStatusModalContent">
                <div className="ticketDetails_UserInfo d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="ticketDetails_Name">
                      {commentType
                        ? "Please add your comments (visible to clients)"
                        : "Please add your private comments"}
                    </div>
                  </div>
                  <div></div>
                </div>
                <div className="AddNoteToTicket">
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      value={commentbox}
                      onChange={(e) => setCommentBox(e.target.value)}
                      rows="3"
                      placeholder="Add Comments here..."
                    ></textarea>
                  </div>

                  {/* External Comment Checkbox Section */}
              
                    <div className="ExternalComment">
                      <div className="ExternalComment_Checkbox">
                        <Form.Check
                          type="checkbox"
                          label="Mark as external comment"
                          name="externalComment"
                          id="externalComment"
                          checked={commentType}
                          // onChange={(e) => setCommentType(e.target.checked)}
                          onChange={handleCheckboxChange}
                        />
                      </div>
                      <div className="ExternalComment_Note">
                        <p className={commentType ? "external-comment" : ""}>
                          <span className="">Note:</span>
                          {commentType
                            ? "Your comment will be sent to the user who created the ticket."
                            : "This comment is internal. Only people from Smartworks who are working on the ticket can see it."}
                        </p>
                      </div>
                    </div>
                

                  {commentType ? (
                    <div className="ExternalComment_TypeRow">
                      <Form.Check
                        type="radio"
                        id="justAComment"
                        name="clientResponseRequired"
                        label="This is just a comment"
                        checked={!clientResponseRequired}
                        onChange={() => setClientResponseRequired(false)}
                        className="ExternalComment_RadioLabel"
                        style={{ marginRight: "2rem" }}
                      />
                      <Form.Check
                        type="radio"
                        id="askingInfo"
                        name="clientResponseRequired"
                        label="I am asking for additional information"
                        checked={clientResponseRequired}
                        onChange={() => setClientResponseRequired(true)}
                        className="ExternalComment_RadioLabel"
                      />
                    </div>
                  ) : ""}

                  <div className="AtachedFileShow">
                    {uploadedFilesComment.map((file, index) => (
                      <div className="AtachedFileBox" key={index}>
                        {getMimeType(file.name) === "application/pdf" ? (
                          <>
                            <img
                              src={PdfFileIcon}
                              alt="PDF Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/webm" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "application/zip" ? (
                          <>
                            <img
                              src={ZipIcon}
                              alt="Zip Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/mp4" ||
                          getMimeType(file.name) === "video/MP4" ||
                          getMimeType(file.name) === "video/mov" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "text/csv" ? (
                          <>
                            <img
                              src={CSVIcon}
                              alt="CSV Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.ms-powerpoint" ? (
                          <>
                            <img
                              src={PowerPointIcon}
                              alt="POWER Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                          <>
                            <img
                              src={DocIcon}
                              alt="Doc Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                          <>
                            <img
                              src={XLSXIcon}
                              alt="XLSX Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : (
                          <>
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`uploaded-file-${index}`}
                              style={{
                                objectFit: "cover",
                                width: "60px",
                                height: "60px",
                              }}
                            />
                          </>
                        )}
                        <div className="AtachedFileBox_Overlay">
                          <img
                            src={AttachementRemoveIcon}
                            alt=""
                            onClick={() => handleRemoveImageComment(index)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="ChangeStatusModalFoot">
              <div className="ChangeStatusModalFoot_content">
                <div className="ModalToolCTA d-flex">
                  <a
                    className="ModalToolCTA_AttacheFile"
                    role="button"
                    onClick={handleIconClickComment}
                  >
                    <img src={AddingAttachementIcon} alt="" />
                  </a>

                  <input
                    type="file"
                    ref={fileInputRef4}
                    style={{ display: "none" }}
                    onChange={handleFileCommentChange}
                    multiple
                  />
                  <div className="ms-2">Attach relevant files</div>
                </div>

                {modalButtonValue === "Comments" ? (
                  <div className="ModalCTA">
                    <button
                      className="btn btn-dark ModalCTA_Dark"
                      onClick={handleSubmitComment}
                      disabled={isLoading || commentbox.trim() === ""}
                    >
                      {isLoading ? (
                        <>
                          <i class="fa fa-refresh fa-spin"></i> Processing
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}

        {modalButtonValue === "Details" && (
          <>
            <div className="ChangeStatusModalBody DetailsModal">
              <div className="ChangeStatusModalContent">
                <div className=" d-flex align-items-center">
                  <div>
                    <Form>
                      <div className="row mb-3">
                        <Form.Group as={Col} md={6} className="FormGroup">
                          <Form.Label className="formLabel">
                            Type Text
                          </Form.Label>
                          <Form.Control
                            className="formInput"
                            type="text"
                            placeholder="Placeholder..."
                          />
                        </Form.Group>

                        <Form.Group as={Col} md={6} className="FormGroup">
                          <Form.Label className="formLabel">
                            Type Select
                          </Form.Label>
                          <Form.Select className="FormSelect">
                            <option>select menu</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} md={12} className="FormGroup">
                          <Form.Label className="formLabel d-block">
                            Radio Label
                          </Form.Label>
                          <Form.Check
                            type="radio"
                            label="Option 1"
                            id="radio1"
                            name="radioGroup"
                            className="DefaultFormCheck"
                            inline
                          />
                          <Form.Check
                            type="radio"
                            label="Option 1"
                            id="radio2"
                            name="radioGroup"
                            className="DefaultFormCheck"
                            inline
                          />
                          <Form.Check
                            type="radio"
                            label="Option 1"
                            id="radio3"
                            name="radioGroup"
                            className="DefaultFormCheck"
                            inline
                          />
                        </Form.Group>

                        <Form.Group as={Col} md={12} className="FormGroup">
                          <Form.Label className="formLabel">
                            Type TextArea
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            className="formTextarea"
                            rows={3}
                            placeholder="Placeholder..."
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            <div className="ChangeStatusModalFoot">
              <div className="ChangeStatusModalFoot_content">
                <div className="ModalToolCTA d-flex">Left</div>

                <div className="ModalToolCTA d-flex">Right</div>

                {modalButtonValue === "Comments" ? (
                  <div className="ModalCTA">
                    <button
                      className="btn btn-dark ModalCTA_Dark"
                      onClick={handleSubmitComment}
                      disabled={isLoading || commentbox.trim() === ""}
                    >
                      {isLoading ? (
                        <>
                          <i class="fa fa-refresh fa-spin"></i> Processing
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}

        {modalButtonValue === "Reassign" && (
          <>
            <div className="ChangeStatusModalBody ReAssignModal">
              <div className="ChangeStatusModalContent">
                <div className="ticketDetails_UserInfo d-flex align-items-center justify-content-between">
                  <div className="ticketDetails_Name">
                    Please provide the reason for reassigning this ticket
                  </div>

                  <div>
                    {/* <select
                      id="group-type-select"
                      className="ReAssign_Department"
                      value={selectedAssignee}
                      onChange={handleChangeAssignee}
                    >
                      <option value="" disabled>Select department</option>
                      {filteredAssignees.map((groupType, index) => (
                        <option key={index} value={groupType}>
                          {groupType === "tc" ? "Tech" :
                       groupType === "it" ? "IT" :
                         groupType === "op" ? "Operations" :
                           groupType === "am" ? "Account Management" : groupType === "md" ? "MSD" : groupType === "is"
                        ? "InfoSec" :
                        groupType === "pj" ? "Project" : ""}
                        </option>
                      ))}
                    </select> */}
                    <select
                      id="group-type-select"
                      className="ReAssign_Department"
                      value={selectedAssignee}
                      onChange={handleChangeAssignee}
                    >
                      <option value="" disabled>
                        Select department
                      </option>
                      {filteredAssignees.map((dept, index) => (
                        <option key={index} value={dept.value}>
                          {dept.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="AddNoteToTicket">
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      value={reassignbox}
                      onChange={(e) => setReassignBox(e.target.value)}
                      rows="3"
                      placeholder="Tell us more..."
                    ></textarea>
                  </div>
                  <div className="AtachedFileShow">
                    {uploadedFilesReassign.map((file, index) => (
                      <div className="AtachedFileBox" key={index}>
                        {getMimeType(file.name) === "application/pdf" ? (
                          <>
                            <img
                              src={PdfFileIcon}
                              alt="PDF Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/webm" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "application/zip" ? (
                          <>
                            <img
                              src={ZipIcon}
                              alt="Zip Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/mp4" ||
                          getMimeType(file.name) === "video/MP4" ||
                          getMimeType(file.name) === "video/mov" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "text/csv" ? (
                          <>
                            <img
                              src={CSVIcon}
                              alt="CSV Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.ms-powerpoint" ? (
                          <>
                            <img
                              src={PowerPointIcon}
                              alt="POWER Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                          <>
                            <img
                              src={DocIcon}
                              alt="Doc Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                          <>
                            <img
                              src={XLSXIcon}
                              alt="XLSX Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : (
                          <>
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`uploaded-file-${index}`}
                              style={{
                                objectFit: "cover",
                                width: "60px",
                                height: "60px",
                              }}
                            />
                          </>
                        )}
                        <div className="AtachedFileBox_Overlay">
                          <img
                            src={AttachementRemoveIcon}
                            alt=""
                            onClick={() => handleRemoveImageReassign(index)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="ChangeStatusModalFoot">
              <div className="ChangeStatusModalFoot_content">
                <div className="ModalToolCTA d-flex">
                  <a
                    className="ModalToolCTA_AttacheFile"
                    role="button"
                    onClick={handleIconClickReassign}
                  >
                    <img src={AddingAttachementIcon} alt="" />
                  </a>

                  <input
                    type="file"
                    ref={fileInputRef5}
                    style={{ display: "none" }}
                    onChange={handleFileReassignChange}
                    multiple
                  />
                  <div className="ms-2">Attach relevant files</div>
                </div>

                {modalButtonValue === "Reassign" ? (
                  <div className="ModalCTA">
                    <button
                      className="btn btn-dark ModalCTA_Dark"
                      onClick={handleSubmitReassign}
                      disabled={
                        isLoading ||
                        reassignbox.trim() === "" ||
                        selectedAssignee === ""
                      }
                    >
                      {isLoading ? (
                        <>
                          <i class="fa fa-refresh fa-spin"></i> Processing
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}

        {modalButtonValue === "Irrelevant" && (
          <>
            <div className="ChangeStatusModalBody IrrelevantModal">
              <div className="ChangeStatusModalContent">
                <div className="ticketDetails_UserInfo d-flex align-items-center justify-content-between">
                  <div className="ticketDetails_Name">
                    Please state your reason
                  </div>
                </div>
                <div className="AddNoteToTicket">
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      value={irrelevantBox}
                      onChange={(e) => setIrrelevantBox(e.target.value)}
                      rows="3"
                      placeholder="Tell us more..."
                    ></textarea>
                  </div>
                  <div className="AtachedFileShow">
                    {uploadedFilesIrrelevant.map((file, index) => (
                      <div className="AtachedFileBox" key={index}>
                        {getMimeType(file.name) === "application/pdf" ? (
                          <>
                            <img
                              src={PdfFileIcon}
                              alt="PDF Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/webm" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "application/zip" ? (
                          <>
                            <img
                              src={ZipIcon}
                              alt="Zip Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "video/mp4" ||
                          getMimeType(file.name) === "video/MP4" ||
                          getMimeType(file.name) === "video/mov" ? (
                          <>
                            <img
                              src={VideoIcon}
                              alt="Video Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) === "text/csv" ? (
                          <>
                            <img
                              src={CSVIcon}
                              alt="CSV Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.ms-powerpoint" ? (
                          <>
                            <img
                              src={PowerPointIcon}
                              alt="POWER Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                          <>
                            <img
                              src={DocIcon}
                              alt="Doc Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : getMimeType(file.name) ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                          <>
                            <img
                              src={XLSXIcon}
                              alt="XLSX Attachment"
                              style={{ objectFit: "cover" }}
                            />
                            <div className="FileName1">
                              {trimFileName(file.name)}
                            </div>
                          </>
                        ) : (
                          <>
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`uploaded-file-${index}`}
                              style={{
                                objectFit: "cover",
                                width: "60px",
                                height: "60px",
                              }}
                            />
                          </>
                        )}
                        <div className="AtachedFileBox_Overlay">
                          <img
                            src={AttachementRemoveIcon}
                            alt=""
                            onClick={() => handleRemoveImageIrrelevant(index)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="ChangeStatusModalFoot">
              <div className="ChangeStatusModalFoot_content">
                <div className="ModalToolCTA d-flex">
                  <a
                    className="ModalToolCTA_AttacheFile"
                    role="button"
                    onClick={handleIconClickIrrelevant}
                  >
                    <img src={AddingAttachementIcon} alt="" />
                  </a>

                  <input
                    type="file"
                    ref={fileInputRef6}
                    style={{ display: "none" }}
                    onChange={handleFileIrrelevantChange}
                    multiple
                  />
                  <div className="ms-2">Attach relevant files</div>
                </div>

                {modalButtonValue === "Irrelevant" ? (
                  <div className="ModalCTA">
                    <button
                      className="btn btn-dark ModalCTA_Dark"
                      onClick={handleSubmitIrrelevant}
                      disabled={isLoading || irrelevantBox.trim() === ""}
                    >
                      {isLoading ? (
                        <>
                          <i class="fa fa-refresh fa-spin"></i> Processing
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ChangeStatusModal;
